import trelloBackbone from './src/trello-backbone';

export default trelloBackbone;
